import React from 'react';
import PropTypes from 'prop-types';

import PowerSwitchRow from '../DetailPageComponents/PowerSwitchRow.jsx';
import { mapUnit, formatValue } from '../util/topic.js';
import { READ, WRITE } from '../Om7Sense';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'

const MAP_STATE_TO_CLASSNAME = {
    "DEGRADED": "critical",
    "DEGRADED_TRANSIENT": "warning",
    "EMPTY": "warning",
    "RUNNING": "good"
};

export class GroupSubscribingComponent extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired,
        logged_in_as: PropTypes.string,
        gatewayName: PropTypes.string,
        activePath: PropTypes.string,
        isDetails: PropTypes.bool,
        isEdit: PropTypes.bool
    }

    static childContextTypes = {
        basePath: PropTypes.string
    }

    getChildContext() {
        return {
            basePath: ""
        };
    }

    state = {
        path: null,
        data: {},
        prm: "-",
        readOnly: !this.context.p.checkPermission(WRITE, this.props.path)
    };

    _isMounted = false;

    path = null;

    sub = null;
    subPrm = null;
    subsSnd = [];

    /**
     * Construct a path to push based on the contents of this component, used when user clicks on this to open details
     **/
    getPushPath = () => {
        if (this.state.data && this.state.data.type === "RACKDEVICE") {
            // Push components
            const parts = this.props.path.split("/");
            return "focus;" + parts.slice(-1)[0]
        } else {
            return this.props.path;
        }
    }

    subscribe = (path) => {
        const self = this, p = this.context.p;
        if (this.sub) {
            this.sub();
        }

        if (this.path !== path) {
            this.path = path;
            
            return p.subscribe(path, self.subChanged, true).then(function (sub, error) {
                if (!self._isMounted) {
                    sub();
                    return;
                }
                self.sub = sub;
            });

            this.setState({
                readOnly: !this.context.p.checkPermission(WRITE, path)
            });
        }
    }

    subChanged = (changed, value) => {
        const self = this;
        this.setState({data: value});

        // Subscribe primary, default to frontpage_Current
        const prmTopic = value.prm ? value.prm : "status/frontpage_Current";
        const prm = this.path + "/" + prmTopic;
        
        p.subscribe(prm, self.prmChanged, true).then (function (sub, error) {
            if (!self._isMounted) {
                sub();
                return;
            }
            self.setState({prmTopic: prmTopic});

            self.subPrm = sub;
        }, function(err) {
            console.log("prm: not found", prm);
        });

        if (value.snd) {
            const sndPaths = value.snd.split(',');
            let validSndFound = false;
            if (sndPaths) {
                const snd = this.path + "/" + sndPaths[0];
                // console.log("snd", snd);
                return p.subscribe(snd, self.sndChanged, true).then (function (sndSub) {
                    if (!self._isMounted) {
                        sndSub();
                        return;
                    }
                    // console.log("snd sub", snd, initialData, error);
                    self.subsSnd.push(sndSub);
                    self.setState({sndTopic: sndPaths[0], sndPath: snd});
                    validSndFound = true;
                }, error => {});
            }
        }
    }

    prmChanged = (changed, value) => {
        if (!this._isMounted) {
            return;
        }
        // console.log("Setting prm to", value);
        this.setState({prm: formatValue(this.state.prmTopic, value), prmRaw: value?.v});
    }

    sndChanged = (changed, value, path, updatedPath) => {
        if (!this._isMounted) {
            return;
        }
        // console.log("updated snd", newValue, updatedPath);
        this.setState({snd: formatValue(this.state.sndTopic, value)});
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.path !== this.path) {
            this.subscribe(this.props.path);
        }
    }

    componentDidUpdate(prevProps) {
        // console.log("GroupSubscribingComponent componentDidUpdate", prevProps.path, this.props.path);
        if (this.props.path !== this.path) {
            this.subscribe(this.props.path);
        }
    }

    componentWillUnmount() {
        this._isMounted = false
        if (this.sub) {
            this.sub();
        }
        this.sub = null;

        if (this.subPrm) {
            this.subPrm();
        }
        this.subPrm = null;

        for (let i in this.subsSnd) {
            this.subsSnd[i]();
        }
        this.subsSnd = [];
    }

    onDelete = () => {
        this.props.deleteCB(this.props.path);
    }

    render() {
        const self = this;
        let className = "item ";
        if (this.context.isDetails) {
            className += " sensor";
        };

        const t = this.context.t;

        // When component is clicked
        let onClickCb = this.props.pushCB ? function () {
            self.props.pushCB(self.getPushPath());
            return false;
        } : null;

        // Clicks on the edit button
        const onEditClickCb = this.props.pushEditCB ? (e) => {
            // Ensure that clicks don't propagate, otherwise we'll also click the main component
            // (onClickCb abpve)
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();

            if (this.context.isEdit) {
                // If this is an edit, cancel the existing edit instead
                self.props.pushCB(self.getPushPath());
            } else {
                // We need the id to edit
                const parts = this.props.path.split("/");
                const ownId = parts.slice(-1)[0];
                // And the parent path so that the data above the edit details ("inbox") gets showed correctly
                self.props.pushEditCB("edit;" + ownId + ";" + self.props.parentPath);
            }
            return false;
        } : null;

        let editButton = null;
        let currentFill = 100;

        if (this.context.activePath === this.props.path) {
            className += " active";
            if (this.context.isEdit) {
                editButton = (
                    <>
                        &nbsp;- <a onClick={onEditClickCb}>{this.context.t('groups.cancel_edit')}</a>
                    </>
                );
                onClickCb = null;
            }
        }

        if (this.context.isEdit) {
            // TODO: shade out
            className += " disabled";
        } else {
            if (!this.state.readOnly) {
                 editButton = (
                    <>
                        &nbsp;<a className="edit" onClick={onEditClickCb}>
                            <FontAwesomeIcon icon={icon({name: 'cog', family: 'sharp', style: 'solid'})} />
                        </a>
                    </>
                );
             }
            // TODO: Get this from a threshold!
            let prmMax = 10;

            if (this.state.prmTopic === "Current" && this.state.data.type !== "RACKDEVICE") {
                prmMax = 24;
            }

            let alarms = null;
            let alarmCount, warningCount;

            if (this.state.data.a?.length || this.state.data.w?.length || this.state.data.ma || this.state.data.mw) {
                alarmCount = (this.state.data.a ? this.state.data.a.length : 0) + this.state.data.ma;
                warningCount = (this.state.data.w ? this.state.data.w.length : 0) + this.state.data.mw;
                alarms = (
                    <>
                        <span className="alarms">{alarmCount} </span>
                        <span className="warnings">{warningCount}</span>
                    </>
                );
            }

            if (alarmCount > 0) {
                className += " critical";
            } else if (warningCount > 0) {
                className += " warning";
            } else {
                className += " " + MAP_STATE_TO_CLASSNAME[this.state.data.state];
            }
        }

        let snd = null;
        // Switches are shown as real switch rows
        if (this.state.sndTopic === "switch") {
            snd = <PowerSwitchRow readOnly={false} dataPath={this.state.sndPath} isInDC={true} />;
        } else {
            snd =
            <>
                <div className="groupAlarms">
                    { /* alarms */ }
                </div>
                <div className="location">
                    {this.state.snd}
                    {this.state.sndUnit && this.state.sndUnit}
                </div>
            </>;
        }

        if (this.context.isDetails) {
            return (
                <div className={className} onClick={onClickCb}>
                    <div className="inner">
                        <div className="columns col-gapless">
                            <div className="column col-3">
                                <h2>{this.state.data.name}{editButton}</h2>
                                <div className="category">
                                    { t(`connectionState.${this.state.data.state?.toLowerCase()}`, this.state.data.state) }
                                    { !this.state.readOnly && (
                                        <a className="delete" onClick={this.onDelete}>
                                            <FontAwesomeIcon icon={icon({name: 'trash', family: 'sharp', style: 'solid'})} />
                                        </a> )}
                                </div>
                            </div>
                            <div className="column col-3">
                                <div className="state">
                                    {snd}
                                </div>
                            </div>
                            <div className="column col-6 valuebg">
                                {this.state.prm}
                            </div>
                        </div>
                        <div className="value" style={{"left": currentFill + "%"}}></div>
                    </div>
                </div>
            );

        } else {
            return (                        
                <div className={className} onClick={onClickCb}>
                    <div className="value" style={{"left": currentFill + "%"}}>
                        Value
                    </div>
                    <h4>{this.state.data.name}</h4>
                    <span>{this.state.prm}</span>
                    <div className="signal"></div>
                </div>
            );
        }


    }

}


GroupSubscribingComponent.propTypes = {
    path: PropTypes.string,
    activePath: PropTypes.string,
    pushCB: PropTypes.func.isRequired,
    pushEditCB: PropTypes.func.isRequired,
    deleteCB: PropTypes.func.isRequired,
    parentPath: PropTypes.string.isRequired
};